/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildMemoDto } from '../../models/child-memo-dto';
import { UpdateChildMemoDto } from '../../models/update-child-memo-dto';

export interface UserChildMemoControllerUpdateMemo$Params {
  teacherUserId?: string;
  guardianUserId?: string;
  memoId: string;
  centerId: string;
      body: UpdateChildMemoDto
}

export function userChildMemoControllerUpdateMemo(http: HttpClient, rootUrl: string, params: UserChildMemoControllerUpdateMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildMemoDto>> {
  const rb = new RequestBuilder(rootUrl, userChildMemoControllerUpdateMemo.PATH, 'patch');
  if (params) {
    rb.query('teacherUserId', params.teacherUserId, {});
    rb.query('guardianUserId', params.guardianUserId, {});
    rb.path('memoId', params.memoId, {});
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildMemoDto>;
    })
  );
}

userChildMemoControllerUpdateMemo.PATH = '/api/child-memo/user/{memoId}';
